import React from 'react';
import ContentBox from "./ContentBox";
import {Link} from "react-router-dom";
import moment from 'moment';

export default function SolicitudesMisRequerimientos({requestList, isLoading, onRequestSelected}) {
    const mapSolicitudStatus = {
        Nuevo: "En proceso",
        Pendiente: "En proceso",
        "En tramite": "En proceso",
        "En Trámite": "En proceso"
    }

    return (
        <React.Fragment>
            <div className="section-title">
                <h1>Mis Casos</h1>
            </div>

            <ContentBox loading={isLoading}>
                {isLoading &&  <div className='h-44' />}
                
                {!isLoading && Boolean(requestList.length) && 
                    <div className="table-container">
                        <table className="table1">
                            <thead>
                                <tr>
                                    <td>N° CASO</td>
                                    <td>Fecha</td>
                                    <td>Servicios</td>
                                    <td>Tipo Requerimiento</td>
                                    <td>Estado</td>
                                    <td></td>
                                </tr>
                            </thead>
                            <tbody>
                                {requestList.map((solicitud, index) => (
                                    <tr key={"tr-element-requerimiento-"+index}>
                                        <td>{solicitud.id}</td>
                                        <td>{moment(solicitud.created_at_date, "YYYY-MM-DD").format("DD-MM-YYYY")}</td>
                                        <td>{solicitud.bussines_lines_name}</td>
                                        <td>{solicitud.request_type_name}</td>
                                        <td>{mapSolicitudStatus[solicitud.status] ?? solicitud.status} </td>
                                        <td>
                                            <div onClick={()=>onRequestSelected(index)} className="linkA-container">
                                                <Link to={{ pathname: "requerimientos/detalle"  }}>
                                                    Detalle
                                                </Link>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table> 
                    </div>
                }

                {!isLoading && !Boolean(requestList.length) && <>Sin datos</>}
            </ContentBox>
        </React.Fragment>
    )
}
